import { ConversationalAgent, defaults } from "./element";

// <script src="https://<agent-host>/widget.js" data-site="mysite" defer></script>
// registers <conversational-agent> and, unless data-launcher="false" or the
// page already has an inline chat, adds the bottom-right launcher.

const script = document.currentScript as HTMLScriptElement | null;
if (script) {
  defaults.site = script.dataset.site;
  defaults.api = script.dataset.api || new URL(script.src).origin;
}

if (!customElements.get("conversational-agent")) customElements.define("conversational-agent", ConversationalAgent);

function mountLauncher() {
  if (!script || !defaults.site || script.dataset.launcher === "false") return;
  if (document.querySelector("conversational-agent")) return;
  const el = document.createElement("conversational-agent");
  el.setAttribute("mode", "launcher");
  for (const attr of ["accent", "theme", "placeholder", "suggestions"]) {
    const value = script.dataset[attr];
    if (value) el.setAttribute(attr, value);
  }
  document.body.appendChild(el);
}

// Astro's ClientRouter (and similar) replaces <body> on navigation; put the
// launcher back. The conversation itself lives on in the shared client.
document.addEventListener("astro:after-swap", mountLauncher);

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mountLauncher);
else mountLauncher();
